import Link from "next/link";

interface TextButtonCTASectionProps {
  lineOne: string;
  lineTwo: string;
  buttonText: string;
  buttonHref: string;
}

const TextButtonCTASection: React.FC<TextButtonCTASectionProps> = ({
  lineOne,
  lineTwo,
  buttonText,
  buttonHref,
}) => {
  return (
    <div className="bg-blue-50">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-24 lg:px-8 lg:flex lg:items-center lg:justify-between">
        <h2 className="text-3xl font-extrabold tracking-tight text-blue-900 sm:text-4xl">
          <span className="block">{lineOne}</span>
          <span className="block text-blue-600">{lineTwo}</span>
        </h2>
        <div className="mt-8 flex lg:flex-shrink-0 lg:mt-0">
          <div className="inline-flex rounded-md shadow">
            <Link href={buttonHref}>
              <a className="bg-blue-600 border border-transparent rounded-md py-3 px-5 inline-flex items-center justify-center text-base font-medium text-white hover:bg-blue-700">
                {buttonText}
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextButtonCTASection;
